import * as THREE from 'three';
import type { QualitySettings } from '../quality/QualitySettings';

export function createRenderer(mount: HTMLElement, quality?: QualitySettings): THREE.WebGLRenderer {
  const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: false,
    powerPreference: 'high-performance'
  });

  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1;

  (renderer as any).physicallyCorrectLights = true;

  const shadowsEnabled = quality ? quality.shadows.enabled : true;
  renderer.shadowMap.enabled = shadowsEnabled;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  mount.appendChild(renderer.domElement);
  return renderer;
}
